import { PLACES_VOCABULARIES } from './places.js';
import { PLACE_FEEDBACK_VOCABULARIES } from './place-feedback.js';
/** Slice d669 of the catalog: the vocabularies of the shared places base (D669), the screens that read it (D671-D674) and the riders' place feedback queue (D704). */
export const SLICE_D669 = [...PLACES_VOCABULARIES, ...PLACE_FEEDBACK_VOCABULARIES];
//# sourceMappingURL=slice-d669.js.map